import { motion, AnimatePresence } from "framer-motion"
import styled from "styled-components"

export default function PageTransitionHolder(props) {
  const { children } = props

  return (
    <AnimatePresence>
      <RouteContainer {...AnimationSettings}>{children}</RouteContainer>
    </AnimatePresence>
  )
}

const RouteContainer = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  /* border: 5px solid black; */
`

const AnimationSettings = {
  transition: { duration: 0.5 },
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
}
